'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useInstantSearch } from 'react-instantsearch';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import avo from 'analytics/avo';
import { ALGOLIA_INDEX_NAME, ALGOLIA_INDEX_LABEL_BY_NAME } from 'commons/constants';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import { getAdvancedSearchUrlForQueryAndIndex } from '../../../../../commons/helpers';

/**
 * Helper component to get hits count for a specific index
 * This is used within Index widget context
 */
const IndexHitsCount = t0 => {
  const $ = _c(15);
  const {
    indexName,
    toggleSearchOpen
  } = t0;
  const {
    results
  } = useInstantSearch();
  const query = results?.query || "";
  const currentPage = useUserCurrentPageType();
  if (!results || !results.nbHits || results.nbHits === 0 || !query) {
    return null;
  }
  let t1;
  if ($[0] !== query) {
    t1 = query.charAt(0).toUpperCase();
    $[0] = query;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const queryWord = t1 + query.slice(1);
  const urlIndexName = indexName === ALGOLIA_INDEX_NAME.STATIC_PAGES ? "static_pages_new" : indexName;
  const indexLabel = ALGOLIA_INDEX_LABEL_BY_NAME[indexName] ?? indexName;
  const displayName = `${queryWord} in ${indexLabel} (${results.nbHits})`;
  let t2;
  if ($[2] !== query || $[3] !== urlIndexName) {
    t2 = getAdvancedSearchUrlForQueryAndIndex(query, urlIndexName);
    $[2] = query;
    $[3] = urlIndexName;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== currentPage || $[6] !== query || $[7] !== toggleSearchOpen) {
    t3 = async () => {
      await toggleSearchOpen();
      avo.productsSearched({
        query,
        location: currentPage,
        searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK
      });
    };
    $[5] = currentPage;
    $[6] = query;
    $[7] = toggleSearchOpen;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = classNames("text-sm font-bold mt-1 mb-1 ml-0 no-underline !leading-[1.5rem] active:bg-gray-light8 focus:bg-gray-light8 hover:bg-gray-light8", {
      "block mr-2.5 text-[#585858]": true
    });
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== displayName || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <Link to={t2} onClick={t3} className={t4}>{displayName}</Link>;
    $[10] = displayName;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
IndexHitsCount.propTypes = {
  indexName: PropTypes.string.isRequired,
  toggleSearchOpen: PropTypes.func
};
export default IndexHitsCount;